export default "__VITE_ASSET___2DJ_tnz__"